import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowLeft } from "lucide-react";
import Reveal from "@/components/Reveal";

const CaseStudies = () => {
  return (
    <>
      <section className="pt-[160px] pb-20 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <div className="font-mono text-[11px] tracking-overline uppercase text-accent mb-6">
          [ Case Studies ]
        </div>
        <h1 className="font-display font-bold text-[3rem] md:text-[5rem] leading-[0.98] tracking-tightest max-w-5xl">
          Real estates,{" "}
          <span className="text-brand">measurable outcomes.</span>
        </h1>
      </section>

      <section className="pb-24 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <article className="bg-paper-warm rounded-md overflow-hidden border border-black/5">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="aspect-[4/3] lg:aspect-auto">
              <img
                src="/hero/engineer-onsite.jpg"
                alt="University of Reading project"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-10 md:p-14 flex flex-col justify-center">
              <div className="font-mono text-[11px] tracking-overline uppercase text-muted mb-4">
                [ Featured · Education ]
              </div>
              <h2 className="font-display font-bold text-[2rem] md:text-[2.75rem] leading-[1.05] tracking-tightest mb-4">
                University of Reading
              </h2>
              <p className="text-[15px] text-muted-foreground leading-relaxed mb-8">
                Fire damper drop testing, surveying and HVAC compliance mapping across
                Whiteknights, London Road and Greenlands campuses — delivered through
                term-time without academic disruption.
              </p>
              <div className="grid grid-cols-3 gap-4 mb-8">
                <div>
                  <div className="font-mono text-accent text-[2rem] leading-none font-medium">77</div>
                  <div className="text-[11px] tracking-overline uppercase text-muted font-mono mt-2">Buildings</div>
                </div>
                <div>
                  <div className="font-mono text-accent text-[2rem] leading-none font-medium">560</div>
                  <div className="text-[11px] tracking-overline uppercase text-muted font-mono mt-2">Dampers</div>
                </div>
                <div>
                  <div className="font-mono text-accent text-[2rem] leading-none font-medium">1,792</div>
                  <div className="text-[11px] tracking-overline uppercase text-muted font-mono mt-2">Hours</div>
                </div>
              </div>
              <Link
                to="/case-studies/university-of-reading"
                data-testid="case-read-detail"
                className="inline-flex items-center gap-2 group"
              >
                <span className="font-semibold border-b border-ink/30 pb-1 group-hover:border-ink">Read the full case study</span>
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </article>
      </section>

      <section id="case-detail" className="py-16 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <div className="font-mono text-[11px] tracking-overline uppercase text-muted mb-6">
          [ More case studies · in progress ]
        </div>
        <p className="text-[17px] text-muted-foreground max-w-2xl leading-relaxed">
          We&rsquo;re writing up recent programmes at Westminster Kitchen, Rose May Hotel and
          St Teresa&rsquo;s Academy. If you&rsquo;d like a specific reference or a walk-through of
          a project like yours, <Link to="/contact" className="text-brand hover:text-accent transition-colors border-b border-brand/30">get in touch</Link> and
          we&rsquo;ll send it directly.
        </p>
      </section>

      <section className="py-24 bg-paper-warm">
        <div className="max-w-editorial mx-auto px-6 md:px-10 lg:px-12 text-center">
          <h3 className="font-display font-bold text-[2rem] md:text-[2.5rem] tracking-tightest mb-6">
            Got a project like this?
          </h3>
          <Link to="/contact" data-testid="case-cta-contact" className="inline-flex items-center gap-2 px-7 py-4 bg-brand text-white font-semibold text-[14px] rounded-sm hover:bg-accent transition-colors">
            Talk to us <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default CaseStudies;
